<script setup>
import { watch } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useValidation } from '@/utils/useValidataion';

const storeSert = useSertStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

const props = defineProps({
    stateKey: {
        type: String,
    },
    responseError: {
        type: Object, 
        default: () => ({ active: false, text: '' })
    },
    required: {
		type: Boolean,
		default: true,
	},
})

watch(
	() => storeSert.checkedItems[props.stateKey]?.title,
	(newVal) => {
        
		if (newVal !== value.value) {
			value.value = newVal ?? "";
		}
	},
	{ immediate: true }
);

</script>
<template>
    <label class="checkbox">
        <div class="checkbox__inner">
            <input 
                type="checkbox" 
                class="checkbox__real-input"
                @change="storeSert.updateCheckedItem(stateKey, 'title', value), validation(stateKey)" 
                v-model="value"
                :required="required"
            >
           
            <span class="checkbox__custom-input"></span>
            <span class="checkbox__text">
                <slot></slot> 
            </span>
        </div>
        <Transition>
            <span v-if="responseError.active" class="input__error">{{ responseError.text }}</span>
        </Transition>
    </label>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.checkbox {

    .input__error {
        position: static;
        font-family: var(--font3);
        font-weight: 400;
        font-size: 1.6rem;
        @media (max-width: vars.$xx) {
            line-height: 110%;
        }
    }
}
.checkbox__inner {
    display: flex;
    align-items: start;
    gap: .8rem;

}
.checkbox__real-input {
	width: 0;
	height: 0;
	opacity: 0;
	position: absolute;
	z-index: -1;
}

.checkbox__custom-input {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-default-3);
    width: 2.4rem;
    height: 2.4rem;
    flex-shrink: 0;
    @media (max-width: vars.$x480) {
        width: 2rem;
        height: 2rem;
    }   
}
.checkbox__text {
	font-family: var(--font3);
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 160%;
    @media (max-width: vars.$xx) {
        line-height: 110%;
    }
    :deep(a) {
        border-bottom: .1rem solid;
        @media (hover: hover){
            &:hover {
                border-color: transparent;
            }
        }
    }
}

.checkbox__custom-input::before {
	content: '';	
    display: inline-block;
	width: 2rem;
	height: 2rem;
	background-image: url('@/assets/img/icons/check_dark.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
	position: absolute;
    transform: scale(0);
    transition: 0.2s ease-in; 
    @media (max-width: vars.$x480) {
        width: 2rem;
        height: 2rem;
    } 
}
.checkbox__real-input:checked + .checkbox__custom-input::before {
	transform: scale(1);
}
.checkbox__real-input:checked + .checkbox__custom-input {
	background-color: #ffffff;
}
.checkbox__real-input:checked ~ .checkbox__text {
	color: var(--text-inverse-100);
}
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translateX(20px);
}
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>